import { useCallback, useEffect, useState } from 'react'

import {
  GET_COMPENSATION_WITHDRAW_ORDERS_CHANGELOG,
  convertParams,
  convertResult,
} from 'app/common/api/requests/cabinet/compensation/withdraw_orders/changelog/get'

import { api } from 'app/api'
import { ChangeLogType, Params } from 'app/dataTypes/cafeteria/compensation/statements/changelog'


type Options = {
  params: Params
  autoload?: boolean
}

const defaultOptions = {
  autoload: true,
}

const defaultState: ChangeLogType = []

export function useCompensationStatementsChangeLog(options: Options) {
  const { autoload, params } = { ...defaultOptions, ...options }
  const { statementID } = params

  const [changeLog, setChangeLog] = useState(defaultState)
  const [loading, setLoading] = useState(true)

  const request = useCallback(async () => {
    setLoading(true)
    const res = await api.request(GET_COMPENSATION_WITHDRAW_ORDERS_CHANGELOG, {
      error: 'Не удалось получить детализацию по заявке',
      params: { statementID },
      convertions: {
        convertParams,
        convertResult,
      },
    })

    setLoading(false)

    if (res) {
      setChangeLog(res)
    }
  }, [statementID])

  useEffect(() => {
    if (autoload) {
      request()
    }
  }, [request, autoload])

  return {
    changeLog,
    loading,
    request,
  }
}
